import * as atob from 'atob';

export async function getAccessToken() {
  const email = process.env.WWW_GOOGLE_API_CLIENT_EMAIL;
  const key = atob(process.env.WWW_GOOGLE_API_PRIVATE_KEY);

  const nowSeconds = Math.floor(Date.now() / 1000);
  const payload = {
    iss: email,
    sub: email,
    aud: 'https://oauth2.googleapis.com/token',
    scope: 'https://www.googleapis.com/auth/drive.readonly',
    iat: nowSeconds,
    exp: nowSeconds + 3600,
  };

  const options = { algorithm: 'RS256' };
  const jwt = await import('jsonwebtoken');

  const signature = jwt.sign(payload, key, options);

  const body = {
    grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
    assertion: signature,
  };

  const tokenResponse = await fetch('https://oauth2.googleapis.com/token', {
    method: 'post',
    body: JSON.stringify(body),
    headers: { Authorization: `Bearer ${signature}` },
  });

  return tokenResponse.status === 200
    ? tokenResponse.json().then(response => response.access_token)
    : Promise.reject();
}

export async function getGoogleDocument(documentId, accessToken) {
  const mimeType = 'text/html';
  const url = `https://www.googleapis.com/drive/v3/files/${documentId}/export?mimeType=${mimeType}`;

  const documentResponse = await fetch(url, {
    method: 'get',
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  return documentResponse.status === 200
    ? documentResponse.text()
    : Promise.reject();
}
